module.exports = __webpack_public_path__ + "img/az.0b4258df.svg";